import PhaseTask from './phase_task';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';

export class SchedulePhaseTask extends PhaseTask {
  onClick = () => {
    this.completeTask();
  }
}

const schedule = connect(() => ({}), { updatePhaseTask, clearValidationErrors })(SchedulePhaseTask);
export { schedule as schedule_install, schedule as schedule_assessment };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/schedule.jsx